import React from "react";

export const Share = React.forwardRef<SVGSVGElement, React.SVGAttributes<SVGElement>>(function Share(props, ref) {
	return (
		<svg ref={ref} fill="currentColor" {...props}>
			<use xlinkHref="#icon-share"></use>
		</svg>
	);
});
